// Staging limits menu item image uploads to 1MB; everywhere else allows 5MB.
// CRA only exposes REACT_APP_* vars; trim so "true " still counts as true.
export const IS_STAGING =
  (process.env.REACT_APP_IS_STAGING || "").trim().toLowerCase() === "true";

export const MAX_IMAGE_SIZE_MB = IS_STAGING ? 1 : 5;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
